export default class HeaderActions {

    initial() {
        this.hoverAction();
        this.clickActionProfile();
        this.hoverCategories();
        this.search();
    }

    /**
     * Hover actions
     * Use on desktop >= 1200px
     */
    hoverAction() {
        let $hoverWrap = $('.hover_wrap'),
            $menuRow = $('.header_menu'),
            deliveryTimeShow = 300,
            deliveryFnShow = null,
            deliveryTimeClear = 300,
            deliveryRnClear = null,
            hId = null,
            deliveryHideBS = null;

        if($hoverWrap.length && $(window).width() >= 1200) {
            //Title hover
            $hoverWrap.find('.hover_item').mouseenter(function () {
                let $this = $(this);
                deliveryHideBS = setTimeout(function () {
                    if(!$this.attr('data-hover-id')) {
                        console.warn('Please set data-hover-id');
                        return false;
                    }

                    $(document).trigger('click.out.profile');

                    //Check if other window is open
                    if(hId && hId !== $this.attr('data-hover-id')) {
                        $hoverWrap.find('.hover_open').removeClass('hover_open');
                        $(hId).fadeOut(100);
                        $menuRow.removeClass('open_b_menu');
                    }

                    //
                    hId = $this.attr('data-hover-id');

                    clearTimeout(deliveryRnClear);
                    if(!$this.hasClass('hover_open')) {
                        deliveryFnShow = setTimeout(function () {
                            //Hide search if it open
                            $(document).trigger('mouseup.out.search');

                            $hoverWrap.find('.hover_open').removeClass('hover_open');
                            $(hId).fadeIn(200);
                            $this.addClass('hover_open');

                            //data-header-class="open_b_menu"
                            if($this.attr('data-header-class')) {
                                $menuRow.addClass('open_b_menu');
                            }
                        }, deliveryTimeShow);

                        //Listen hover child
                        $(hId).mouseenter(function () {
                            clearTimeout(deliveryRnClear);
                        }).mouseleave(function () {
                            clearTimeout(deliveryFnShow);
                            clear();
                        })
                    }
                }, 200);
            }).mouseleave(function () {
                clearTimeout(deliveryFnShow);
                clearTimeout(deliveryHideBS);
                clear();
            });

        }

        function clear() {
            clearTimeout(deliveryRnClear);
            deliveryRnClear = setTimeout(function () {
                clearTimeout(deliveryFnShow);
                $hoverWrap.find('.hover_open:not(.no_remove)').removeClass('hover_open');
                //TODO: unbind?
                //$(hId).unbind('mouseenter');
                //$(hId).unbind('mouseleave');
                $(hId).fadeOut(200);
                hId = null;
                $menuRow.removeClass('open_b_menu');
            }, deliveryTimeClear);
        }
    }

    /**
     * For profile forms Register|Login
     */
    clickActionProfile() {
        let $clickAction = $('.hover_wrap .click-profile');
        if($clickAction.length && $(window).width() >= 1200) {
            $clickAction.on('click', function () {
                let id = $(this).attr('data-click-id');
                if(id) {
                    $(this).toggleClass('hover_open no_remove');
                    $(id).fadeToggle(200);
                    if($(this).hasClass('hover_open')) {
                        setEventClose(true);
                    } else {
                        setEventClose(false);
                    }
                }
            });
        }

        //Click on document
        function setEventClose(set) {
            if(set === true) {
                $(document).bind('click.out.profile', function (e) {
                    let $loginDesktop = $('#login_desktop');
                    if (!$loginDesktop.is(e.target) && $loginDesktop.has(e.target).length === 0
                        && !$clickAction.is(e.target) && $clickAction.has(e.target).length === 0) {
                        $loginDesktop.fadeOut(200);
                        $clickAction.removeClass('hover_open no_remove');
                        $(document).unbind('click.out.profile');
                    }
                });
            } else {
                $(document).unbind('click.out.profile');
            }
        }
    }

    /**
     * Hover actions for categories
     * Use on desktop >= 1200px
     */
    hoverCategories() {
        let $catDesktop = $('#category_desktop'),
            $menuRow = $('.header_menu'),
            deliveryHover = null;

        if($catDesktop.length && $(window).width() >= 1200) {
            $catDesktop.find('.first a').mouseenter(function () {
                let $this = $(this);
                deliveryHover = setTimeout(function () {
                    let id = $this.attr('data-id');

                    $this.parent().find('.active').removeClass('active');
                    $this.addClass('active');

                    if (id) {
                        $menuRow.addClass('open_b_menu');
                        $catDesktop.find('.first').removeClass('rounded_border');
                        $catDesktop.find('.second').fadeIn(200);
                        $catDesktop.find('.second > div').animate({opacity: 0}, 200, function() {
                            $catDesktop.find('.second > div').hide();

                            $catDesktop.find(id).show();
                            $catDesktop.find(id).animate({opacity: 1}, 200);
                        });
                    } else {
                        $menuRow.removeClass('open_b_menu');
                        $catDesktop.find('.first').addClass('rounded_border');
                        $catDesktop.find('.second').fadeOut(200, function () {
                            $catDesktop.find('.second > div').fadeOut(0);
                        })
                    }
                }, 300)
            });

            $catDesktop.find('.first a').mouseleave(function () {
                clearTimeout(deliveryHover);
            });

            //Hide all
            $catDesktop.mouseleave(function () {
                $menuRow.removeClass('open_b_menu');
                $catDesktop.find('.second').fadeOut(100, function () {
                    $catDesktop.find('.first').addClass('rounded_border');
                    $catDesktop.find('.second > div').fadeOut(0);
                    $catDesktop.find('a.active').removeClass('active');
                })
            })
        }
    }

    /**
     * Search inputs
     * Desktop|Mobile
     */
    search() {
        let $searchInput = $('#search_desktop_input'),
            $searchPopup = $('#search_desktop');

        //Desktop
        if($searchInput.length && $(window).width() >= 1200) {
            $searchInput.focus(function () {
                $(this).parent().parent().addClass('active');
                setEventClose(true);
            });

            //TODO: дублювання, звести до спільного
            let timer = null;
            $searchInput.keyup(function () {
                let val = $(this).val(),
                    formData = new FormData();

                if(val.length >= 3) {
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        formData.append('q', val);
                        $.ajax({
                            type: "POST",
                            url: $searchInput.attr('data-ajax'),
                            processData: false,
                            contentType: false,
                            data: formData
                        }).done(function (res) {
                            if(res.found && res.found === true) {
                                $searchPopup.html(res.html);
                                $searchPopup.fadeIn(200);
                            } else {
                                $searchPopup.fadeOut(200, function () {
                                    $searchPopup.html('');
                                });
                            }

                        });
                    }, 500);
                } else {
                    $searchPopup.fadeOut(200);
                }
            });

            //Clear & close
            $searchInput.siblings('.icon-clear').on('click', function () {
                $searchPopup.fadeOut(200, function () {
                    $searchInput.parent().parent().removeClass('active');
                    $searchInput.val('');
                    $searchInput.blur();
                    setEventClose(false);
                });
            });
        }

        //Click on document
        function setEventClose(set) {
            if(set === true) {
                $(document).bind('mouseup.out.search', function (e) {
                    let $inputSearch = $searchInput.parent();
                    if (!$inputSearch.is(e.target) && $inputSearch.has(e.target).length === 0
                        && !$searchPopup.is(e.target) && $searchPopup.has(e.target).length === 0) {
                        $searchInput.siblings('.icon-clear').trigger('click');
                    }
                });
            } else {
                $(document).unbind('mouseup.out.search');
            }
        }

        //Mobile
        let $mSearch = $('#search_slide'),
            $mSearchRes = $('#xhr-mob-search'),
            timer = null;
        if($searchInput.length && $(window).width() <= 1199) {
            $mSearch.find('input[type="search"]').keyup(function () {
                let val = $(this).val(),
                    formData = new FormData();
                if(val.length >= 3) {

                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        formData.append('q', val);

                        $.ajax({
                            type: "POST",
                            url: $searchInput.attr('data-ajax'),
                            processData: false,
                            contentType: false,
                            data: formData
                        }).done(function (res) {
                            if(res.found && res.found === true) {
                                $mSearchRes.html(res.html);
                                $mSearchRes.fadeIn(200);
                            } else {
                                $mSearchRes.fadeOut(200, function () {
                                    $mSearchRes.html('');
                                });
                            }
                        });
                    }, 500);

                } else {
                    $mSearchRes.fadeOut(200);
                }

                //Hide|Show clear input
                if(val.length > 0) {
                    $mSearch.find('.search_input .icon-clear').css('display', 'block');
                } else {
                    $mSearch.find('.search_input .icon-clear').removeAttr('style');
                    $mSearchRes.fadeOut(200);
                }
            });

            //Clear input
            $mSearch.find('.search_input .icon-clear').on('click', function () {
                $mSearch.find('input[type="search"]').val('');
                $(this).removeAttr('style');
                $mSearchRes.fadeOut(200);
            });

        }
    }
}
